var React = require('react');

function LightningWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.217 6.07 4.197.146C3.293-.389 2.276.66 2.942 1.44l3.94 4.612a.835.835 0 0 1 0 1.098L.205 14.964c-.39.458-.204 1.136.376 1.363l19.426 7.6c.912.356 1.73-.658 1.107-1.372L11.639 11.72a.835.835 0 0 1-.003-1.111l2.81-3.238c.357-.41.25-1.017-.229-1.3Z","fill":"#fff"}));
}

LightningWhite.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = LightningWhite;

LightningWhite.default = LightningWhite;
